import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  ITag,
  ITagListRequest,
  ITagCreateRequest,
  ITagUpdateRequest,
  TagState,
} from "@/types/tag";
import CustomRequest from "../customRequest";

const actions: ActionTree<TagState, RootState> = {
  async get({ commit }, tag_id: number) {
    await CustomRequest.get<IPagination<ITag>>({
      uri: `/tag/${tag_id}`,
      commit,
      target: "single",
    });
  },

  async getList({ commit }, params: ITagListRequest) {
    await CustomRequest.get<IPagination<ITag>>({
      uri: "/tag",
      params,
      commit,
      target: "pagination",
    });
  },

  async saleUpdate(
    { commit },
    datas: { tag_id: number; params: ITagUpdateRequest }
  ) {
    const { error } = await CustomRequest.patch<IPagination<ITag>>({
      uri: `/sales/tag/${datas.tag_id}`,
      params: datas.params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async saleCreate({ commit }, params: ITagCreateRequest) {
    const { error } = await CustomRequest.post<IPagination<ITag>>({
      uri: `/sales/tag/`,
      params: params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async saleDelete({ commit }, tag_id: number) {
    const { error } = await CustomRequest.delete({
      uri: `/sales/tag/${tag_id}`,
      flash: true,
    });

    return !error;
  },
};

export default actions;
